"use client"

import { Button, TbExternalLink } from "@forestsync/ui"
import Link from "next/link"
import { useTranslations } from "next-intl"

interface UserSectionProps {
  size?: "xs" | "sm" | "md" | "lg"
}

export function UserSection({ size = "sm" }: UserSectionProps) {
  const t = useTranslations("navigation")
  const marketplaceUrl = process.env.NEXT_PUBLIC_MARKETPLACE_URL || "https://carbonomex.com"

  return (
    <Button
      component={Link}
      href={marketplaceUrl}
      target="_blank"
      rel="noopener noreferrer"
      variant="light"
      color="orange"
      leftSection={<TbExternalLink size={16} />}
      size={size}
    >
      {t("carbonExchange")}
    </Button>
  )
}
